<section class="execute-order-management">
    <div class="row">
      <div class="col-md-12">
        <app-breadcrumb [title3]="'ExecuteOrder.MENUTitle'">
        </app-breadcrumb>
  
      </div>
      <div class="col-md-12">
        <div class="common-tabbing manage-supplier-tab">
          <mat-tab-group animationDuration="0ms" (click)="tabChangedClick($event)"
            (selectedTabChange)="tabChanged($event)" #tabGroup [selectedIndex]="selectedTab">
            <mat-tab *ngFor="let tabInfo of orderTabbing" class="mt-5" label="{{tabInfo.label}}"
              aria-label="{{tabInfo.indexNumber}}">
              <ng-template mat-tab-label>
                {{tabInfo.label | translate}} <span class="count-label">{{tabInfo.count ? tabInfo.count : '0'}}</span>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
          <div class="table-content box-style company-info">
            <div class="table-heading">
              <h3 style="font-weight: 600">{{'ExecuteOrder.MENUTitle' | translate}}
                <span (click)="onRefreshTable()" class="refresh-btn"
                  matTooltip="Refresh"><mat-icon>autorenew</mat-icon></span>
              </h3>
              <div class="search-form-wrapper">
    
                <div class="search-form">
                  <mat-icon matPrefix class="material-icons search">search</mat-icon>
                  <input (keyup)="onKeyUp($event)" #searchBox [(ngModel)]="search" mat-input
                    placeholder="{{'ORDERMANAGEMENT.SearchCatalog'| translate}}" />
                  <mat-icon *ngIf="this.search !== '' " class="material-icons clear"
                    (click)="resetSearch()">clear</mat-icon>
                </div>
  
  
              </div>
            </div>
            <div class="table-wrapper">
              <table #table
                [dataSource]="executeOrderData | paginate: {itemsPerPage: this.itemsPerPage, currentPage: this.page, totalItems: this.totalItems }"
                mat-table style="width: 100%">
  
                <ng-container matColumnDef="proposalId">
                  <th (click)="changeSorting('proposalId',sortBy)" *matHeaderCellDef class="short-arrow" mat-header-cell>
                    {{'ExecuteOrder.proposalId' | translate}} <span
                      [ngClass]="{'down': sortKey === 'proposalId' && sortBy === '-1' , 'up': sortKey === 'proposalId' && sortBy === '1'}">
                      <img alt="" src="assets/images/up-arrow.svg"></span> </th>
                  <td mat-cell *matCellDef="let element" style="white-space: break-spaces;text-transform:capitalize;">{{
                    element.proposalId ? element.proposalId : '-' }}</td>
                </ng-container>
  
                <ng-container matColumnDef="orderName">
                  <th (click)="changeSorting('orderName',sortBy)" *matHeaderCellDef class="short-arrow" mat-header-cell>
                    {{'ExecuteOrder.Title'| translate}} <span
                      [ngClass]="{'down': sortKey === 'orderName' && sortBy === '-1' , 'up': sortKey === 'orderName' && sortBy === '1'}">
                      <img alt="" src="assets/images/up-arrow.svg"></span> </th>
                  <td mat-cell *matCellDef="let element" style="white-space: break-spaces;text-transform:capitalize;">{{
                    element.orderName ? element.orderName : '-' }}</td>
                </ng-container>

  
                <ng-container matColumnDef="details">
                  <th *matHeaderCellDef mat-header-cell>
                    {{'TABLE.Action' | translate}} </th>
                  <td mat-cell *matCellDef="let element">
                    <div class="actions-btn" style=" gap: 10px;width:300px;">
                      <button class="btn-style table-btn theme-line-btn sm-btn" (click)="viewExecuteOrderDetail(element)">
                      {{ ('TABLE.ViewDetails') | translate}}
                    </button>
                      <button *ngIf="element.status === executeOrderStatus.ReviewOrder" (click)="changeStatusApprove(element)" class="btn-style table-btn green-btn sm-btn"
                        style="min-width:80px;">
                        {{'ORDERMANAGEMENT.MANAGEORDERS.Approve' | translate}}
                      </button>
                      
                      <button  *ngIf="element.status === executeOrderStatus.ReviewOrder" (click)="changeStatusReject(element)" class="btn-style table-btn red-btn sm-btn"
                        style="min-width:80px;">
                        {{'ORDERMANAGEMENT.MANAGEORDERS.Reject' | translate}}
                      </button>
                    </div>
                  </td>
                </ng-container>
  
                <ng-container matColumnDef="completionTime">
                  <th (click)="changeSorting('completionTime',sortBy)" *matHeaderCellDef class="short-arrow"
                    mat-header-cell>
                    {{'ExecuteOrder.ExpectedTimeToComplete'| translate}} <span
                      [ngClass]="{'down': sortKey === 'completionTime' && sortBy === '-1' , 'up': sortKey === 'completionTime' && sortBy === '1'}">
                      <img alt="" src="assets/images/up-arrow.svg"></span>
                  </th>
                  <td mat-cell *matCellDef="let element" style="white-space:  break-spaces;text-transform: capitalize;">{{
                    (element.completionTime | date : 'dd/MM/yyyy') }}</td>
                </ng-container>
  
  
  
  
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef>
                    {{'ExecuteOrder.Status'| translate}}
                  </th>
                  <td mat-cell *matCellDef="let element" style="white-space: break-spaces;text-transform:capitalize;">
                    <span *ngIf="element.status === executeOrderStatus.NotStarted"
                      class="btn-style table-btn theme-line-btn sm-btn label-btn">
                      {{'ExecuteOrder.NotStarted' | translate}}
                    </span>
  
                    <span *ngIf="element.status === executeOrderStatus.InProgress"
                      class="btn-style in-progress label-btn sm-btn table-btn">
                      {{'ExecuteOrder.InProgress' | translate}}
                    </span>
  
                    <span *ngIf="element.status === executeOrderStatus.Completed"
                      class="btn-style active abel-btn sm-btn table-btn">
                      {{'ExecuteOrder.Completed' | translate}}
                    </span>

                    <span *ngIf="element.status === executeOrderStatus.ReviewOrder"
                      class="btn-style active abel-btn sm-btn table-btn">
                      {{'ExecuteOrder.ReviewOrder' | translate}}
                    </span>

                    <span *ngIf="element.status === executeOrderStatus.Reject"
                      class="btn-style inactive abel-btn sm-btn table-btn">
                      {{'ExecuteOrder.Rejected' | translate}}
                    </span>
                  </td>
                </ng-container>
  
  
                <tr mat-header-row *matHeaderRowDef="documentDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let element; columns: documentDisplayedColumns"></tr>
              </table>  
            </div>
            <app-pagination [noRecordFound]="noRecordFound" [itemsPerPage]="itemsPerPage" [page]="page"
            (pageChange)="pageChanged($event)" (changeItem)="changeItemsPerPage($event)"
            [totalItems]="totalItems"></app-pagination>
  
          </div>
  
        </div>
      </div>
    </div>
  </section>